import React, { ChangeEvent, FormEvent, useState } from 'react';
import { Link } from 'react-router-dom';
import { forgetPassword } from '../../services/auth';
import { showError, showSuccess } from '../Alert';
import '../../styles/Login.css';
import '../../styles/LoginForm.css';

const ForgotPassword: React.FC = () => {
  const [email, setEmail] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();
    if (isLoading) return;

    if (!email.trim()) {
      showError('Please enter your email address');
      return;
    }

    try {
      setIsLoading(true);
      await forgetPassword({ email: email.trim() });
      setSubmitted(true);
      showSuccess('Password reset email sent');
    } catch (err: any) {
      const message =
        err?.response?.data?.message ||
        err?.response?.data ||
        'Failed to send password reset email';
      showError(typeof message === 'string' ? message : 'Request failed');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-box text-bg-light rounded-5">
        <h3 className="text-center pt-2 mt-2 fw-semibold">Forgot Password</h3>
        <hr />
        <div className="login-form-wrapper">
          <form onSubmit={handleSubmit} noValidate>
            <p className="auth-helper-text">
              Enter the email address on your account and we&apos;ll send you a
              password reset link.
            </p>

            <div className="input-group mt-3">
              <label htmlFor="forgotEmail" className="input-group-text">
                <i className="bi bi-envelope-fill"></i>
              </label>
              <input
                id="forgotEmail"
                type="email"
                className="form-control input-box"
                placeholder="Email address"
                value={email}
                onChange={(e: ChangeEvent<HTMLInputElement>) =>
                  setEmail(e.target.value)
                }
                required
                disabled={isLoading || submitted}
              />
            </div>

            <div className="my-4 text-center">
              <button
                type="submit"
                className="btn btn-lg btn-outline-dark"
                disabled={isLoading || submitted}
              >
                {isLoading ? (
                  <span className="spinner-border spinner-border-sm" />
                ) : submitted ? (
                  'Email Sent'
                ) : (
                  'Send Reset Link'
                )}
              </button>
            </div>

            <div className="signup-text">
              <Link to="/login" className="link">
                Back to Login
              </Link>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
